// Mock data shared by landing demo and dashboard

export const initialNodes = [
  // Core tasks
  { id: "task:auth-jwt",        group: "task",      label: "implement JWT auth",        confidence: 0.88 },
  { id: "task:rate-limit",      group: "task",      label: "add rate limiting",         confidence: 0.76 },
  { id: "task:parse-json",      group: "task",      label: "stream JSON parser",        confidence: 0.62 },
  { id: "task:db-migration",    group: "task",      label: "alembic migration drift",   confidence: 0.70 },
  { id: "task:embed-search",    group: "task",      label: "vector search tuning",      confidence: 0.74 },
  { id: "task:incident-db",     group: "task",      label: "DB timeout incident",       confidence: 0.83 },
  { id: "task:deploy-railway",  group: "task",      label: "deploy to Railway",         confidence: 0.91 },
  { id: "task:slack-bot",       group: "task",      label: "Slack bot OAuth flow",      confidence: 0.67 },
  { id: "task:ci-pipeline",     group: "task",      label: "CI pipeline failing",       confidence: 0.72 },

  // Lessons
  { id: "lesson:rotate-secret",    group: "lesson", label: "Rotate JWT secret per env",        confidence: 0.92 },
  { id: "lesson:bcrypt-rounds",    group: "lesson", label: "Use bcrypt rounds=12",             confidence: 0.84 },
  { id: "lesson:redis-bucket",     group: "lesson", label: "Token bucket > fixed window",      confidence: 0.81 },
  { id: "lesson:ijson-stream",     group: "lesson", label: "ijson for >1MB payloads",          confidence: 0.79 },
  { id: "lesson:no-eval-yaml",     group: "lesson", label: "Never yaml.load() user input",     confidence: 0.97 },
  { id: "lesson:autogen-review",   group: "lesson", label: "Review autogen migrations",        confidence: 0.86 },
  { id: "lesson:hnsw-ef",          group: "lesson", label: "ef_search=80 sweet spot",          confidence: 0.78 },
  { id: "lesson:conn-pool",        group: "lesson", label: "Max pool size = CPU cores × 2",    confidence: 0.89 },
  { id: "lesson:retry-jitter",     group: "lesson", label: "Add jitter to exp. backoff",       confidence: 0.88 },
  { id: "lesson:env-secrets",      group: "lesson", label: "Secrets in env, never argv",       confidence: 0.95 },
  { id: "lesson:slack-scopes",     group: "lesson", label: "Request minimal OAuth scopes",     confidence: 0.77 },
  { id: "lesson:docker-layer",     group: "lesson", label: "Copy requirements before code",    confidence: 0.82 },
  { id: "lesson:pgvector-index",   group: "lesson", label: "ivfflat lists = rows / 1000",      confidence: 0.74 },
  { id: "lesson:cache-warm",       group: "lesson", label: "Warm cache before peak traffic",   confidence: 0.80 },

  // Procedures
  { id: "proc:auth-bootstrap",  group: "procedure", label: "Auth bootstrap workflow",   confidence: 0.95 },
  { id: "proc:secure-deploy",   group: "procedure", label: "Secure deploy checklist",   confidence: 0.90 },
  { id: "proc:reflection-loop", group: "procedure", label: "Reflection loop",           confidence: 0.93 },
  { id: "proc:incident-response", group: "procedure", label: "Incident response",       confidence: 0.88 },
];

export const initialLinks = [
  // Auth cluster
  { source: "task:auth-jwt",      target: "lesson:rotate-secret" },
  { source: "task:auth-jwt",      target: "lesson:bcrypt-rounds" },
  { source: "task:auth-jwt",      target: "proc:auth-bootstrap" },
  { source: "proc:auth-bootstrap",target: "lesson:bcrypt-rounds" },
  { source: "proc:auth-bootstrap",target: "lesson:env-secrets" },
  { source: "task:slack-bot",     target: "lesson:slack-scopes" },
  { source: "task:slack-bot",     target: "lesson:rotate-secret" },

  // Rate limiting
  { source: "task:rate-limit",    target: "lesson:redis-bucket" },
  { source: "task:rate-limit",    target: "lesson:retry-jitter" },
  { source: "task:rate-limit",    target: "proc:secure-deploy" },

  // JSON / parsing
  { source: "task:parse-json",    target: "lesson:ijson-stream" },
  { source: "proc:secure-deploy", target: "lesson:no-eval-yaml" },
  { source: "proc:secure-deploy", target: "lesson:rotate-secret" },
  { source: "proc:secure-deploy", target: "lesson:env-secrets" },

  // DB
  { source: "task:db-migration",  target: "lesson:autogen-review" },
  { source: "task:incident-db",   target: "lesson:conn-pool" },
  { source: "task:incident-db",   target: "lesson:retry-jitter" },
  { source: "task:incident-db",   target: "proc:incident-response" },
  { source: "proc:incident-response", target: "lesson:conn-pool" },

  // Vector / embed
  { source: "task:embed-search",  target: "lesson:hnsw-ef" },
  { source: "task:embed-search",  target: "lesson:pgvector-index" },
  { source: "proc:reflection-loop",target: "lesson:hnsw-ef" },
  { source: "proc:reflection-loop",target: "lesson:ijson-stream" },
  { source: "proc:reflection-loop",target: "lesson:autogen-review" },

  // Deploy / CI
  { source: "task:deploy-railway",target: "lesson:docker-layer" },
  { source: "task:deploy-railway",target: "lesson:env-secrets" },
  { source: "task:deploy-railway",target: "proc:secure-deploy" },
  { source: "task:ci-pipeline",   target: "lesson:docker-layer" },
  { source: "task:ci-pipeline",   target: "lesson:cache-warm" },
  { source: "task:ci-pipeline",   target: "proc:secure-deploy" },

  // Cross-links (knowledge graph connections)
  { source: "lesson:conn-pool",   target: "lesson:retry-jitter" },
  { source: "lesson:rotate-secret",target: "lesson:env-secrets" },
];

export const eventStreamSeed = [
  { t: "14:02:03", kind: "CAPTURE", text: "Failed to parse JSON → reflection queued", tone: "amber" },
  { t: "14:02:11", kind: "REFLECT", text: "lesson generated · ijson for >1MB payloads · conf=0.79", tone: "cyan" },
  { t: "14:02:17", kind: "RECALL",  text: "matched 3 lessons for task='stream JSON parser'", tone: "cyan" },
  { t: "14:02:24", kind: "CAPTURE", text: "agent=coder-7 · success=true · t=2.4s", tone: "green" },
  { t: "14:02:31", kind: "REFLECT", text: "procedure promoted · Auth bootstrap workflow · conf=0.95", tone: "cyan" },
  { t: "14:02:39", kind: "WARN",    text: "contradiction detected · lesson 0x4F2 vs 0x91A", tone: "pink" },
  { t: "14:02:46", kind: "CAPTURE", text: "agent=ops-2 · success=true · t=0.9s", tone: "green" },
  { t: "14:02:54", kind: "RECALL",  text: "matched 5 lessons for task='alembic migration drift'", tone: "cyan" },
];

export const confidenceSeries = Array.from({ length: 30 }, (_, i) => ({
  run: i + 1,
  baseline: Math.max(0.32, 0.42 + Math.sin(i / 4) * 0.04 - i * 0.002),
  mnemo: Math.min(0.98, 0.38 + i * 0.02 + Math.sin(i / 3) * 0.03),
}));

export const agentList = [
  { id: "coder-7",  role: "Coding agent · py", health: 0.92, lessons: 184 },
  { id: "ops-2",    role: "DevOps · k8s",       health: 0.81, lessons: 96  },
  { id: "scribe-1", role: "Docs writer",         health: 0.74, lessons: 41  },
  { id: "qa-3",     role: "Test triage",          health: 0.88, lessons: 120 },
];

export const proceduresList = [
  { id: "PR-001", name: "Auth bootstrap workflow",  uses: 412,  conf: 0.95, tags: ["auth", "fastapi"] },
  { id: "PR-002", name: "Secure deploy checklist",  uses: 298,  conf: 0.90, tags: ["security", "ops"] },
  { id: "PR-003", name: "Reflection loop",          uses: 1244, conf: 0.93, tags: ["core", "meta"] },
  { id: "PR-004", name: "Vector index tuning",      uses: 87,   conf: 0.78, tags: ["pgvector"] },
];
